import React from 'react';
import { Cpu, Edit3 } from 'lucide-react';

export default function BuilderStepTwo({ glassClass, handleModeSelect }) {
    return (
        <div className={`${glassClass} !p-8 grid grid-cols-1 md:grid-cols-2 gap-8`}>
            <button onClick={() => handleModeSelect('AI')} className="bg-gradient-to-br from-black/60 to-black/40 hover:to-orange-900/20 border border-orange-500/20 p-8 rounded-2xl flex flex-col items-center text-center gap-4 transition-all group relative overflow-hidden shadow-md">
                <div className="absolute top-0 right-0 p-3 bg-orange-500 text-xs font-black rounded-bl-xl text-white uppercase tracking-widest shadow-lg">Tip</div>
                <div className="bg-orange-500/10 p-6 rounded-full group-hover:scale-110 transition-transform"><Cpu size={48} className="text-orange-400"/></div>
                <div>
                    <h3 className="text-2xl font-black text-white uppercase tracking-wider mb-3">Smart AI Coach</h3>
                    <p className="text-sm text-gray-400 leading-relaxed max-w-sm mx-auto">Laat MYWOD een geoptimaliseerde template voor je genereren op basis van je niveau. Je kunt daarna alles zelf nog aanpassen.</p>
                </div>
            </button>
            <button onClick={() => handleModeSelect('Manual')} className="bg-black/40 hover:bg-black/60 border border-white/10 hover:border-white/30 p-8 rounded-2xl flex flex-col items-center text-center gap-4 transition-all group shadow-md">
                <div className="bg-white/5 p-6 rounded-full group-hover:scale-110 transition-transform"><Edit3 size={48} className="text-gray-300"/></div>
                <div>
                    <h3 className="text-2xl font-black text-white uppercase tracking-wider mb-3">Eigen Training</h3>
                    <p className="text-sm text-gray-400 leading-relaxed max-w-sm mx-auto">Je weet precies wat je wilt doen of je volgt een extern schema. Begin met een leeg scherm en bouw je eigen sessie op.</p>
                </div>
            </button>
        </div>
    );
}
